"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Roles___StyledSvg",
  componentId: "sc-1b0t1pn-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function Roles(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    d: "M7.342 11.085c-1.748 0-3.171-1.439-3.171-3.207 0-1.768 1.423-3.207 3.17-3.207 1.749 0 3.171 1.439 3.171 3.207 0 1.768-1.422 3.207-3.17 3.207zm0-4.81c-.875 0-1.586.718-1.586 1.603 0 .884.71 1.604 1.586 1.604.875 0 1.585-.72 1.585-1.604 0-.885-.71-1.604-1.585-1.604zM13.683 17.5H1v-.802c0-2.833 2.607-4.81 6.342-4.81 3.734 0 6.341 1.977 6.341 4.81v.802zM2.711 15.896h9.262c-.474-1.45-2.246-2.405-4.63-2.405-2.385 0-4.158.956-4.632 2.405zM14.476 8.21l-2.939-2.973 1.121-1.133 1.818 1.838L17.879 2.5 19 3.634 14.476 8.21z",
    fill: "currentColor"
  }));
}

var _default = Roles;
exports["default"] = _default;